export class InvoiceUtil {

    static toHtml(x, club) {
      return `
        <style>
          body {
            width: 1000px;
          }
          .invoice-container {
            font-family: "Source Sans Pro", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
            padding: 20px;
            margin: auto;
            max-width: 800px;
          }
          .text-center {
            text-align: center;
          }
          .text-right {
            text-align: right;
          }
          .text-left {
            text-align: left;
          }
          .invoice-container h1 {
            margin: 30px 0 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid #ddd;
          }
          .invoice-container p {
            margin: 0;
            line-height: 2;
          }
          .h2 {
            font-size: 30px;
            margin-top: 20px;
          }
          .invoice-container table {
            width: 100%;
          }
          .invoice-container .table-bordered {
            margin-bottom: 20px;
            border: 1px solid #ddd;
            border-collapse: collapse;
          }
          .invoice-container .table-bordered tr td,
          .invoice-container .table-bordered tr th {
            border: 1px solid #ddd;
            padding: 8px;
            line-height: 1.42857143;
          }
          .invoice-container address {
            margin-bottom: 20px;
            font-style: normal;
            line-height: 1.42857143;
            font-size: 16px;
          }
          .invoice-container table tr td {
            vertical-align: baseline;
          }
        </style>
        <div class="invoice-container">
          <div>#INV</div>
          <h1 class="text-center">RECEIPT</h1>
          <table class="invoice-table">
            <tr>
              <td>
                <p class="h2 font-w400 push-5">TGS</p>
                <address>
                202 Fashion Lane #101<br>
                Tustin, CA 92780<br>
                <i class="si si-call-end"></i><span></span> <span>1-855-847-1805</span>
                </address>
              </td>
              <td class="text-right">
                <p class="h2 font-w400 push-5">${club.name}</p>
                <address>
                ${club.address}<br>
                ${club.city}<br>
                ${club.statecode}, ${club.zip}<br>
                </address>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <table class="table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 50px;"></th>
                      <th class="text-left">${ x.invoice.invoice }</th>
                      <th class="text-center" style="width: 80px;">Quantity</th>
                      <th class="text-right" style="width: 140px;">Payment Date</th>
                      <th class="text-right" style="width: 80px;">Unit</th>
                      <th class="text-right" style="width: 120px;">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                  ` + x.details.map((d, idx) => `
                      <tr>
                        <td class="text-center">${ idx + 1 }</td>
                        <td>
                            <h2 style="font-size: 15px; margin-top: 0px;">
                            ${ d.fullName }
                            </h2>
                            <div class="description">${ d.description }</div>
                        </td>
                        <td class="text-center"><span style="background: cornflowerblue;" class="badge badge-primary">1</span></td>
                        <td class="text-right">${ d.paymentDate ? new Date(d.paymentDate).toLocaleDateString() : '' }</td>
                        <td class="text-right">$${ (d.amount || 0).toFixed(2) }</td>
                        <td class="text-right">$${ (d.amount || 0).toFixed(2) }</td>
                      </tr>`).join('\n') + `
                      <tr>
                        <td colspan="5" class="font-w600 text-right">Subtotal</td>
                        <td class="text-right">$${ (x.invoice.amount || 0).toFixed(2) }</td>
                      </tr>
                      <tr>
                        <td colspan="5" class="font-w600 text-right">Total Paid</td>
                        <td class="text-right">$${ (x.invoice.amount - (x.invoice.discount_amount || 0)).toFixed(2) }</td>
                      </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </table>
        </div>
      `;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/utils/invoice.util.ts